import { Controller } from "@hotwired/stimulus";
import ky from "ky";

// Connects to data-controller="edit-venue"
export default class extends Controller {
  static targets = [
    "name",
    "address",
    "lat",
    "lng",
    "placeId",
    "addressComponents",
  ];
  connect() {}

  async save() {
    const frame = this.element.closest("turbo-frame");
    const baseUrl = this.element.dataset.url;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const persisted = this.element.dataset.persisted;

    const venue = {
      name: this.nameTarget.value,
      address: this.addressTarget.value,
      lat: this.latTarget.value,
      lng: this.lngTarget.value,
      place_id: this.placeIdTarget.value,
      address_components: this.addressComponentsTarget.value,
    };

    if (persisted === "false") {
      const params = new URLSearchParams();
      Object.entries(venue).forEach(([key, value]) => {
        if (value) params.append(`venue[${key}]`, value);
      });
      const separator = baseUrl.includes("?") ? "&" : "?";
      frame.src = `${baseUrl}${separator}${params.toString()}`;
    } else {
      try {
        await ky.patch(baseUrl, {
          json: { event: { venue } },
          headers: {
            "X-CSRF-Token": csrfToken,
            Accept: "application/json",
          },
        });

        frame.src = baseUrl.replace(".json", "");
      } catch (error) {
        console.error("Failed to save venue:", error);
      }
    }
  }
}
